import angular from 'angular';
import loanInformationImportantDates from './loanInformationImportantDates';
import './style.scss';

export default angular
  .module('components.loanInformationImportantDates', [])
  .component('loanInformationImportantDates', loanInformationImportantDates)
  .name;
